import React, {useState, useEffect, useContext} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import StepFooterAction from "../../base-components/step-footer-action";
import BaseParagraph from "../../base-components/base-paragraph";
import { ImPencil } from 'react-icons/im';
import {useHistory} from "react-router-dom";
import { BASE_URL } from '../../../env';
import NACE from "assets/data/NACE.json";
import { CountryContext } from 'contexts/country-context';

const SummaryPersoStep = ({ _step_service, step_ID, next_step , getStep}) => {
    const countryValue = useContext(CountryContext)
    const lang = localStorage.getItem('language')
    const marital_options = {
           1:t('personal_infos.Personal_info_civil_state.married'),
        2:t('personal_infos.Personal_info_civil_state.single'),
        3:t('personal_infos.Personal_info_civil_state.widower'),
        4:t('personal_infos.Personal_info_civil_state.divorced'),
        5:t('personal_infos.Personal_info_civil_state.defacto_separated'),
        6:t('personal_infos.Personal_info_civil_state.separated'),
        7:t('personal_infos.Personal_info_civil_state.legal_cohabitee'),
       }
        
    

    const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`

    const [isLoading, setIsLoading] = useState(false)
    const [isValid, setIsValid] = useState(false)
    const history = useHistory();

    const [firstname, setfirstname] = useState('')
    const [lastname, setlastname] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [adresse, setAdress] = useState('')
    const [birthDate, setBirthDate] = useState('')
    const [placeOfBirth, setPlaceOfBirth] = useState('')
    const [countryOfBirth, setcountryOfBirth] = useState('')
    const [nationality, setNationality] = useState('')
    const [marital, setMarital] = useState('')
    const [ready, setReady] = useState(false)

    const fetch_POST_init_options = {
        method: 'POST',
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }

    const fetch_GET_init_options = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }

    const fetch_POST_init = {
        ...fetch_POST_init_options,
        body: JSON.stringify(
            [{
            fieldId: "internal_confirm_flag",
            fieldValue: "1"
            }]
        )
    }

    useEffect(() => {
        getData()
                    if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                        pageID: "onboarding",
                        stepSeq: "1",
                        stepName: "personal info:review",
                        eventAction: "stepEnd",
                        flowType: "sales",
                        flowName: "onboarding",
                        productName: "onboarding",
                        trackMethod: "flow"
                    }
                );
            }
    }, [])
    
    async function getData() {
        getStep(["first_name", "last_name", "email", "internal_mobile_country_code", "internal_mobile_phone_number", "street", "house_number", "box", "zip_code", "city", "birthday"
        , "internal_postal_input", "internal_placeOfBirth_country", "internal_nationality_country","civil_state"]).then(res => {
            console.log(res)
            res["first_name"] && setfirstname(res["first_name"])
            res["last_name"] && setlastname(res["last_name"])
            res["email"] && setEmail(res["email"])
            res["civil_state"] && setMarital(res["civil_state"])
            res["internal_postal_input"] && setPlaceOfBirth(res["internal_postal_input"])
            res["internal_placeOfBirth_country"] && setcountryOfBirth(res["internal_placeOfBirth_country"])

            if (res["internal_nationality_country"]) {
                const obj = JSON.parse(res["internal_nationality_country"])
               setNationality(Object.values(obj).map(item=> (item.name)).join(', '))
           }
                
            
            res["birthday"] && setBirthDate(res["birthday"].split("-").reverse().join('/'))
            res["internal_mobile_country_code"] && res["internal_mobile_phone_number"] && setPhone(`+${res["internal_mobile_country_code"]} ${res["internal_mobile_phone_number"]}`)
            res['street'] && res['house_number'] && res['zip_code'] && res['city'] && setAdress(`${res['street']} ${res['house_number']} ${res['box']  ? "/" + res['box']: ""} ${res['zip_code']} ${res['city'] }`)
        })
        // // has_enterprise
        // const hasEnterprise = await (await fetch(`${base_URL}/has_enterprise`, fetch_GET_init_options)).json()
        // setHasEnterprise(hasEnterprise.fieldValue === "1")

        // const name = await (await fetch(`${base_URL}/enterprise_name`, fetch_GET_init_options)).json()
        // setName(name.fieldValue)

        // const nace = await (await fetch(`${base_URL}/enterprise_activity_code`, fetch_GET_init_options)).json()
        // const naceCode = nace.fieldValue.split(",").reverse()[0]
        // const _naceCOde = NACE.find(nace => nace.CODE === naceCode)
        // setActivity(_naceCOde[`NAME_${lang}`])

        // const countryActivity = await (await fetch(`${base_URL}/enterprise_activity_country`, fetch_GET_init_options)).json()
        // const __countryActivity = await (await fetch(`${BASE_URL}/onboarding-entrepreneur-front/v1/countries/${lang}`, fetch_GET_init_options)).json()

        // const countryArr = []
        // countryActivity.fieldValue.split(';').forEach(code => countryArr.push(__countryActivity.find(c => c.iso2 === code).title))
        // setCountry(countryArr.join(","))

        // const num = await (await fetch(`${base_URL}/enterprise_number`, fetch_GET_init_options)).json()
        // setNumber(num.fieldValue.replace(/[0-9_]{4}?/, '$&.').replace(/[0-9_]{4}.[0-9_]{3}?/, '$&.'))

     
    }

    useEffect(() => {
        if ([firstname, lastname, email, phone, adresse, birthDate, placeOfBirth, countryOfBirth, nationality, marital].every(a => a !== '')) {
            setReady(true)
        }
    }, [firstname, lastname, email, phone, adresse, birthDate, placeOfBirth, countryOfBirth, nationality, marital])

    const action = () => {
        // fetch(base_URL, fetch_POST_init).catch( error => {
        //     console.log("error : "+ error)
        // })
     history.push(`/${lang.toLowerCase()}/intro-legal`);
    }

    return (
        <>
            <StepsLoader step_ID={step_ID} loading={isLoading}>
                <BaseParagraph>
                    <h3>{t('personal_infos.Personal_info_review.title')}</h3>
                </BaseParagraph>
                <ul className="summary-block">

                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_name") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${firstname} ${lastname}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("identity")
                        }}> <ImPencil /> </div>
                    </li>
                       <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_email_address-email") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${email}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("email")
                        }}> <ImPencil /> </div>
                    </li>

                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_phone_number-mobile") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${phone}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("phone")
                        }}> <ImPencil /> </div>
                    </li>

                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_home_address") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${adresse}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("legal-address")
                        }}> <ImPencil /> </div>
                    </li>

                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_birth_date-birthday") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${birthDate}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("date-of-birth")
                        }}> <ImPencil /> </div>
                    </li>

                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_birth_place-birth_country") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${countryOfBirth}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("place-of-birth")
                        }}> <ImPencil /> </div>
                    </li>

                     <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_birth_place-birth_place") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${placeOfBirth}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("place-of-birth")
                        }}> <ImPencil /> </div>
                    </li>

      
                     <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_nationality-nationality") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${nationality}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("nationality")
                        }}> <ImPencil /> </div>
                    </li>

                    
                     <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("personal_infos.Personal_info_review.personal_info_civil_status-civil_state") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {`${marital_options[marital]}`} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("marital-status")
                        }}> <ImPencil /> </div>
                    </li>
         
                    {/* <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("pro_infos.pro_info_review.legal_title") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> { t("pro_infos.pro_info_review.legal_label") }  </div>
                    </li> */}
                </ul>
                
                <StepFooterAction caption={t('general.continue')} action={action} disabled={!ready} />
                
            </StepsLoader> 
        </>
    )
}

SummaryPersoStep.propTypes = {
    name: PropTypes.string
}

SummaryPersoStep.defaultProps = {
    name: "email-step"
}


export default SummaryPersoStep